import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3fc9af05"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "recovery-container"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "El enlace de recuperación no es válido o ha expirado.", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_9 = { class: "animate" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Introduce tu nueva contraseña", -1))
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label-space" }, "Nueva contraseña", -1))
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label-space" }, "Repetir contraseña", -1))
const _hoisted_15 = { class: "feedback" }
const _hoisted_16 = {
  key: 0,
  class: "spacer"
}

import main from '@/data/main.js'
import { onMounted, ref } from 'vue'
import RecoveryService from '@/services/RecoveryService'
import { useRoute } from 'vue-router'
import router from '@/router'
import { useToast } from '@/store/useToast'
import { Toast } from '@/interfaces/ToastInterface'


export default /*#__PURE__*/_defineComponent({
  __name: 'RecoveryNewPass',
  setup(__props) {

const service = new RecoveryService()
const route = useRoute()
const loading = ref(false)
const token = ref(route.params.id)
const isValid = ref(true)
const password =ref('')
const new_password =ref('')
const feedback = ref('')
const toast = useToast()

onMounted(async () => {
    loading.value = true
    isValid.value = await service.checkIfValid(token.value)
    loading.value = false
})
 
const handleUpdatePassword =async()=>{
    loading.value= true
    if(password.value!= new_password.value){
        feedback.value ="Las contraseñas no coinciden."
        loading.value = false
        return
    }
    if(password.value.length<6){
        feedback.value = "La contraseña debe tener al menos 6 caracteres."
        loading.value = false
        return
    }
      const response = await service.updatePassword(token.value,password.value,new_password.value)
      if(response){
        toast.showToast("Contraseña actualizada correctamente.", Toast.SUCCESS)
        setTimeout(function () { toast.hideToast() }, 4000);
        router.push({name:'auth'})
      }
      else{
        feedback.value="Ocurrió un error, inténtalo de nuevo más tarde."
      }
      loading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_icon, {
          name: "ri-loader-2-fill",
          animation: "spin",
          class: "icon"
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (!isValid.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _unref(main).LOGO_URI,
                class: "logo",
                width: "352"
              }, null, 8, _hoisted_7),
              _hoisted_8,
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("form", null, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _withDirectives(_createElementVNode("input", {
                        type: "password",
                        required: "",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event))
                      }, null, 512), [
                        [_vModelText, password.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _withDirectives(_createElementVNode("input", {
                        type: "password",
                        required: "",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((new_password).value = $event))
                      }, null, 512), [
                        [_vModelText, new_password.value]
                      ])
                    ]),
                    _createElementVNode("input", {
                      type: "submit",
                      value: "Actualizar",
                      class: "go-btn",
                      onClick: _withModifiers(handleUpdatePassword, ["prevent"])
                    }),
                    _createElementVNode("p", _hoisted_15, _toDisplayString(feedback.value), 1),
                    (feedback.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
      ]))
}
}

})